import React from 'react';
import { theme } from '../../theme';

// Tiny rounded pill for table-cell status / kind labels. Hard-coded color
// presets keep status meaning consistent across pages — never roll your own
// {bg, fg} pair, add the preset here once and reuse.
const PRESETS = {
  // Bills
  draft:          { bg: '#e5e7eb', fg: '#374151' },
  finalized:      { bg: '#dbeafe', fg: '#1e40af' },
  'partial-paid': { bg: '#fef3c7', fg: '#92400e' },
  paid:           { bg: '#d1fae5', fg: '#065f46' },
  cancelled:      { bg: '#fee2e2', fg: '#991b1b' },
  credited:       { bg: '#ede9fe', fg: '#6d28d9' },
  // Bill types
  invoice:        { bg: '#dbeafe', fg: '#1e40af' },
  proforma:       { bg: '#fef3c7', fg: '#92400e' },
  'credit-note':  { bg: '#ede9fe', fg: '#6d28d9' },
  // Generic
  pending:        { bg: '#fef3c7', fg: '#92400e' },
  success:        { bg: '#d1fae5', fg: '#065f46' },
  warning:        { bg: '#fef3c7', fg: '#92400e' },
  danger:         { bg: '#fee2e2', fg: '#991b1b' },
  info:           { bg: '#dbeafe', fg: '#1e40af' },
  neutral:        { bg: '#f1f5f9', fg: '#475569' },
  // Booking kinds (used by OnlineBookings approval queue)
  new:            { bg: theme.primary + '18', fg: theme.primary },
  reschedule:     { bg: '#fef3c7', fg: '#92400e' },
  cancel:         { bg: '#fee2e2', fg: '#991b1b' },
};

export default function StatusPill({
  status,
  preset,             // explicit preset key — if set, overrides status lookup
  tone,               // alias for `preset` — kept for callers that prefer the
                      //   "tone" wording (treats neutral/success/warning/danger/etc).
  bg, fg,             // explicit colors — override both
  icon,               // optional ReactNode rendered before label (e.g. bell)
  label,              // explicit label — defaults to status / children
  size = 'md',        // 'sm' | 'md'
  style,
  children,           // alternative to label — `<StatusPill>VOID</StatusPill>`
}) {
  const p = PRESETS[preset || tone || status] || PRESETS.neutral;
  const padding = size === 'sm' ? '2px 7px' : '3px 10px';
  const fontSize = size === 'sm' ? '0.68rem' : '0.74rem';
  // children takes priority over label (lets callers write
  // <StatusPill tone="danger">VOID</StatusPill>); falls back to status
  // so legacy callers `<StatusPill status='paid'/>` still render 'paid'.
  const content = children != null && children !== '' ? children : (label || status);
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '4px',
        padding, borderRadius: '12px',
        fontSize, fontWeight: '700',
        backgroundColor: bg || p.bg,
        color: fg || p.fg,
        textTransform: 'uppercase', letterSpacing: '0.02em',
        ...style,
      }}
    >
      {icon}
      {content}
    </span>
  );
}
